// extracted by mini-css-extract-plugin
export default {"title":"cnbbrruu7x7Iua7w42Q1","content":"CyDaB_3VfU_DeZ2myV2K","card":"CfRtmG0NNcdabVlXJof7","cell":"UuHVJnRgGcdENsPnnGwZ"};